import { gql } from 'apollo-angular';

export const AutocompleteOccupations = gql`
  query AutocompleteOccupations($keyword: String!) {
    autocompleteOccupations(keyword: $keyword) {
      id
      name
    }
  }
`;

export const OccupationByOnetCode = gql`
  query OccupationByOnetCode($onetCode: ID!) {
    occupationByOnetCode(onetCode: $onetCode) {
      onetCode
      primaryIndustryId
      primaryIndustryName
    }
  }
`;

// No zipCode on purpose. With one, salaryAnalysis now returns zip or county Census estimates, and
// on 2026-10-02 those included $7,229 a year for security guards in Terre Haute (47807). Without
// one it returns the national BLS figure, which is coarse but sane.
export const NationalOccupationSalary = gql`
  query NationalOccupationSalary($onetCode: ID!) {
    occupationByOnetCode(onetCode: $onetCode) {
      salaryAnalysis(onetCode: $onetCode) {
        medianAnnualSalary
        minimumAnnualSalary
        maximumAnnualSalary
        salaryPrecisionType
      }
    }
  }
`;

export const OccupationsByCipCode = gql`
  query OnetCodesByCipCode($cipCode: String!) {
    occupationListByCipCode(cipCode: $cipCode) {
      onetCode
      primaryIndustryId
    }
  }
`;
